import { Navigate, useLocation } from "react-router-dom";

/** Redirects legacy `/nd1/*` preview URLs to canonical routes. */
export default function Nd1LegacyRedirect() {
  const { pathname, search, hash } = useLocation();
  let target = pathname.replace(/^\/nd1/, "") || "/";
  if (target === "/home") target = "/";
  return <Navigate to={`${target}${search}${hash}`} replace />;
}
